// Unpublished Work © 2020-2024 Deere & Company.

import React from 'react';
import PropTypes from 'Utils/prop-type-utils';
import {connect} from 'react-redux';
import RedesignFooter from 'Ui/components/footer/redesign-footer';
import {replaceTranslationNames} from 'Utils/translation-utils';
import {openDialog} from 'Store/actions/dialogs';
import dialogTypes from 'Ui/components/common/dialog-types';

function Footer(props) {
    const {
        hideContent,
        openContactUsDialog,
        openFeedbackDialog,
        translations
    } = props;

    const copyrightWithYear = React.useMemo(() => replaceTranslationNames(translations.ONLINK_FOOTER_COPYRIGHT, {
        '0': new Date().getFullYear()
    }), [translations.ONLINK_FOOTER_COPYRIGHT]);

    return (
        <RedesignFooter
            copyrightWithYear={copyrightWithYear}
            hideContent={hideContent}
            openContactUsDialog={openContactUsDialog}
            openFeedbackDialog={openFeedbackDialog}
            translations={translations}
        />
    );
}

Footer.propTypes = {
    hideContent: PropTypes.bool,
    membershipId: PropTypes.string,
    openContactUsDialog: PropTypes.func,
    openFeedbackDialog: PropTypes.func,
    translations: PropTypes.translations
};

export function mapDispatchToProps(dispatch) {
    return {
        openContactUsDialog(props) {
            dispatch(openDialog(dialogTypes.CONTACT_US_DIALOG, props));
        },
        openFeedbackDialog(props) {
            dispatch(openDialog(dialogTypes.FEEDBACK_DIALOG, props));
        }
    };
}

export default connect(null, mapDispatchToProps)(Footer);
